import { FONT_PRIMARY } from "@/theme/typography";
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography, useTheme } from "@mui/material";
import useResponsive from "@/hooks/useResponsive";

const AdvantageItem = ({ icon: Icon, title, list }: { icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>, title: string, list: string[] }) => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "md");
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", md: "600px"},
        ":first-of-type": {
          marginBottom: { xs: "16px", md: "0px" }
        },
        ":last-child": {
          marginTop: { xs: "16px", md: "0px" }
        },
        height: "100%"
      }}
    >
      <Box
        sx={{
          marginBottom: { xs: "24px", md: "32px" },
          display: "flex",
          alignItems: "center"
        }}
      >
        <Box
          sx={{
            marginRight: { xs: "16px", md: "24px" },
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Icon width={isMobile ? "32px" : "56px"} height={isMobile ? "32px" : "56px"} />
        </Box>
        <Typography
          sx={{
            fontSize: { xs: "1.25", md: "1.5rem" },
            fontWeight: "700",
            fontFamily: FONT_PRIMARY
          }}
        >
          {title}
        </Typography>
      </Box>
      <List
        sx={{
          paddingY: "0px",
          "& .MuiListItem-root": {
            paddingX: "0px",
            alignItems: "start",
            ":first-of-type": {
              paddingTop: "0px"
            },
            ":last-child": {
              paddingBottom: "0px"
            },
            "& .MuiListItemText-root": {
              marginY: "0px"
            },
            "& .MuiListItemText-primary": {
              fontSize: { xs: "0.875rem", md: "1.125rem"},
              fontFamily: FONT_PRIMARY
            },
            "& .MuiListItemIcon-root": {
              minWidth: { xs: "19px", md: "25px"},
              height: { xs: "19px", md: "25px" },
              alignItems: "center",
              justifyContent: "center"
            }
          }
        }}
      >
        {list.map((item, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <Box 
                sx={{
                  width: { xs: "5px", md: "2px" },
                  height: { xs: "5px", md: "2px" },
                  borderRadius: "5px",
                  backgroundColor: theme.palette.common.black
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary={item}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default AdvantageItem;